export default __webpack_public_path__ + "media/images/tenant/colored_background-0baa27309101a4d199b048e56b45c337.svg";